import React, { useLayoutEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategories,
  selectCategories,
  selectSuccess,
  updateCategory,
} from "../../redux/features/category/CategorySlice";
import { BiPencil } from "react-icons/bi";

const EditCategory = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [errors, setErrors] = useState({});

  const categories = useSelector(selectCategories);
  const category = categories.find((category) => category._id === id);
  //   console.log(category);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => {
    setIsOpen(false);
    setErrors({});
  };

  useLayoutEffect(() => {
    if (category) {
      setCategoryName(category.name);
    }
  }, [category]);

  const validateForm = () => {
    const newErrors = {};
    if (!categoryName) newErrors.categoryName = "Name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  const isSuccess = useSelector(selectSuccess);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    console.log("Form Data:", { categoryName });
    const updateCategoryData = {
      id,
      name: categoryName,
    };
    console.log(updateCategoryData);
    await dispatch(updateCategory(updateCategoryData));

    if (isSuccess) {
      await dispatch(getCategories());
      handleClose();
    }
  };

  return (
    <div>
      {/* Button to open the modal */}
      <button
        onClick={handleOpen}
        className="absolute text-white bg-[#20BEC6CC] rounded-lg p-[4px] top-3 right-3"
      >
        <BiPencil className="size-4" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[450px] w-[70%] mx-auto p-5 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
              <h1 className="md:text-[1.5rem] text-[1rem] font-bold text-[#0D868C]">
                Update Category
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className="size-6 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Category Name
                </label>
                <input
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  type="text"
                  placeholder="Name"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.categoryName && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.categoryName}
                  </p>
                )}
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] w-[50%] py-3 rounded-full outline-none uppercase font-normal text-[.9rem]"
                >
                  Update Category
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditCategory;
